module.exports = __webpack_public_path__ + "img/erin-patterson7.a4ab4116.png";